import React from "react";
import { Link } from "react-router-dom";
import MotionReveal from "./MotionReveal";
import HomeSectionHeading from "./HomeSectionHeading";
import { resolveHomeIcon } from "./HomeIcons";

function AudienceSurface({ index }) {
  if (index === 0) {
    return (
      <div className="public-home-premium__audience-surface public-home-premium__audience-surface--employer" aria-hidden="true">
        <div className="public-home-premium__audience-metric-grid">
          <article>
            <span>Passung</span>
            <strong>belastbar</strong>
            <p>Strukturierter Kandidatenkontext statt Profilmasse</p>
          </article>
          <article>
            <span>Dokumente</span>
            <strong>geprüft</strong>
            <p>Nachweisqualität und Lücken bleiben lesbar</p>
          </article>
          <article>
            <span>Pflichten</span>
            <strong>sichtbar</strong>
            <p>Welcome, Wohnraum und Integration gehören dazu</p>
          </article>
        </div>
        <div className="public-home-premium__audience-panel-note">Entscheidungsraum statt Datenbanklogik</div>
      </div>
    );
  }

  return (
    <div className="public-home-premium__audience-surface public-home-premium__audience-surface--talent" aria-hidden="true">
      <div className="public-home-premium__audience-flow public-home-premium__audience-flow--steps">
        {["01 Dokumente", "02 Readiness", "03 Ankommen"].map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
      <div className="public-home-premium__audience-panel-note">Klarer Pfad statt klassischer Vermittlungsstrecke</div>
    </div>
  );
}

export default function HomeAudienceSplit({ content }) {
  return (
    <section className="public-home-premium__section public-home-premium__section--dual" id="audience">
      <div className="mx-auto flex w-full max-w-page flex-col gap-10 px-4 sm:px-6 lg:px-8">
        <HomeSectionHeading eyebrow={content.eyebrow} title={content.title} tone="inverse" />

        <div className="grid gap-5 lg:grid-cols-2">
          {(content.audiences || []).map((audience, index) => {
            const Icon = resolveHomeIcon(audience.icon);
            const toneClass = index === 0 ? "is-employer" : "is-talent";
            const eyebrow = audience.eyebrow || (index === 0 ? "Operative Sicht" : "Orientierungspfad");

            return (
              <MotionReveal key={audience.title} delay={0.05 + index * 0.06}>
                <article className={`public-home-premium__audience-card ${toneClass}`.trim()}>
                  <div className="public-home-premium__audience-card-head">
                    <span className="public-home-premium__mini-label">{eyebrow}</span>
                    <span className="public-home-premium__icon-chip">
                      <Icon size={18} strokeWidth={1.8} />
                    </span>
                  </div>

                  <div className="flex flex-col gap-4">
                    <h3>{audience.title}</h3>
                    <p>{audience.text}</p>
                  </div>

                  <AudienceSurface index={index} />

                  <div className="public-home-premium__audience-list">
                    {(audience.points || []).map((item) => (
                      <span key={item}>{item}</span>
                    ))}
                  </div>

                  <Link to={audience.href} className="public-home-premium__audience-cta">
                    {audience.ctaLabel}
                  </Link>
                </article>
              </MotionReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
